import { FeatureHubGuard } from "@/featureFlags";
import { Button } from "@/overlay/components/CommonParts/buttons";
import { WindowKind, instanceId, useDesktop } from "@/overlay/components/window";
import { t } from "@lingui/core/macro";

export function PortfolioManagerButton(props: { label?: string; onOpen?: () => void }) {
  const desktop = useDesktop();
  const label = props.label ?? t`Portfolio Manager`;
  return (
    <FeatureHubGuard flag="portfolio_manager">
      <Button
        type="button"
        icon="folder_open"
        aria-label={label}
        onClick={() =>
          props.onOpen
            ? props.onOpen()
            : desktop.dispatch({
                type: "setWindowVisibility",
                windowId: instanceId(WindowKind.PortfolioManagerWindow),
                isVisible: true,
              })
        }
      >
        {label}
      </Button>
    </FeatureHubGuard>
  );
}
